import type { Attachment } from '@/types/attachment';
export const NewsType = {
  School: 'school',
  SystemInfo: 'systeminfo',
  Commercial: 'commercial',
} as const;

export type NewsType = (typeof NewsType)[keyof typeof NewsType];

export interface NewsItem {
  title: string;
  body: string;
  lastModificationDate: string;
  isNew: boolean;
  isImportant: boolean;
  attachments: Attachment[];
  titleImageId?: string;
  type?: NewsType;
  galleryId?: string;
}
